// extracted by mini-css-extract-plugin
export default {"button-group":"button-group__wxarh","button-group--full":"button-group--full__uEjT9","button-group__item":"button-group__item__bfIjy"};